/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonEventGroupInfo,
    JsonEventGroupInfoFromJSON,
    JsonEventGroupInfoFromJSONTyped,
    JsonEventGroupInfoToJSON,
} from './JsonEventGroupInfo';

/**
 * 
 * @export
 * @interface ApiResultOfJsonEventGroupInfo
 */
export interface ApiResultOfJsonEventGroupInfo {
    /**
     * 
     * @type {JsonEventGroupInfo}
     * @memberof ApiResultOfJsonEventGroupInfo
     */
    data?: JsonEventGroupInfo;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventGroupInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonEventGroupInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventGroupInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonEventGroupInfo
     */
    result?: ApiResultOfJsonEventGroupInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonEventGroupInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonEventGroupInfoFromJSON(json: any): ApiResultOfJsonEventGroupInfo {
    return ApiResultOfJsonEventGroupInfoFromJSONTyped(json, false);
}

export function ApiResultOfJsonEventGroupInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonEventGroupInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonEventGroupInfoFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonEventGroupInfoToJSON(value?: ApiResultOfJsonEventGroupInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonEventGroupInfoToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

